import React, { useContext } from "react";
import { recruitmentDetailContext } from "../../RecruitmentDetailPage";
import { Box } from "@mui/material";

export default function CloseRecruitmentRadioButton() {
  const { reason, setReason, projectStatus } = useContext(
    recruitmentDetailContext
  );

  const handleChangeReason = (e) => {
    if (projectStatus !== 9) {
      setReason(Number(e.target.value));
    }
  };

  return (
    <Box style={{ paddingTop: "10px" }}>
      <label>
        <input
          type="radio"
          value={1}
          onChange={handleChangeReason}
          checked={reason === 1}
          style={{ accentColor: "#28345E" }}
        />
        充足
      </label>
      &nbsp;
      <label>
        <input
          type="radio"
          value={2}
          onChange={handleChangeReason}
          checked={reason === 2}
          style={{ accentColor: "#28345E" }}
        />
        募集中断
      </label>
      &nbsp;
      <label>
        <input
          type="radio"
          value={3}
          onChange={handleChangeReason}
          checked={reason === 3}
          style={{ accentColor: "#28345E" }}
        />
        内容変更
      </label>
    </Box>
  );
}
